import { useContext, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useStatsigClient } from '@statsig/react-bindings';

import { SURVEY_TYPES } from '@api/instant_survey';
import { maxQuestionError } from '@api/surveys';
import { IconButton, OverlayPopover, PlusIcon } from '@utilities';
import { GATES } from '@constants';

import { SurveyContext } from '../../../../utilities/context';

import styles from './_index.module.scss';

const AddQuestionIconButton = ({ className, onAddQuestion, onCreateQuestion }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const { client } = useStatsigClient();

  const hasQuestionLibrary = client.checkGate(GATES.QUESTION_LIBRARY);

  const buttonRef = useRef();
  const { currentQuestionCount, instantSurveyType, maxQuestions } = useContext(SurveyContext);
  const isSequentialMonadicSurvey = instantSurveyType?.id === SURVEY_TYPES.SEQUENTIAL_MONADIC;
  const isVideoSurvey = instantSurveyType?.id === SURVEY_TYPES.VIDEO;
  const canAddQuestion = isVideoSurvey
    ? currentQuestionCount < 1
    : currentQuestionCount < maxQuestions;
  const hasDropdownOptions = hasQuestionLibrary || isSequentialMonadicSurvey;

  const handleOnAdd = () => {
    setIsPopoverOpen(false);
    onAddQuestion();
  };
  const handleOnCreate = () => {
    setIsPopoverOpen(false);
    onCreateQuestion();
  };
  const handleOnCreateMonadicSection = () => {
    setIsPopoverOpen(false);
  };

  return (
    <>
      <IconButton
        className={className}
        isDisabled={!canAddQuestion}
        onClick={hasDropdownOptions ? () => setIsPopoverOpen(true) : handleOnCreate}
        ref={buttonRef}
        tooltip={canAddQuestion ? 'Add Question' : maxQuestionError}
      >
        <PlusIcon />
      </IconButton>
      {hasDropdownOptions && (
        <OverlayPopover
          className={styles['add-question-icon-button-dropdown']}
          isActive={isPopoverOpen}
          onHide={() => setIsPopoverOpen(false)}
          target={buttonRef?.current}
        >
          <ul>
            <li>
              <button onClick={handleOnCreate}>
                <span>Create Question</span>
                <PlusIcon />
              </button>
            </li>
            {hasQuestionLibrary && (
              <li>
                <button onClick={handleOnAdd}>
                  <span>Add From Library</span>
                  <PlusIcon />
                </button>
              </li>
            )}
            {isSequentialMonadicSurvey && (
              <li>
                <button onClick={handleOnCreateMonadicSection}>
                  <span>Create Monadic Section</span>
                  <PlusIcon />
                </button>
              </li>
            )}
          </ul>
        </OverlayPopover>
      )}
    </>
  );
};

AddQuestionIconButton.propTypes = {
  className: PropTypes.string,
  onAddQuestion: PropTypes.func.isRequired,
  onCreateQuestion: PropTypes.func.isRequired,
};

export default AddQuestionIconButton;
